import { useStrings } from 'src/ui/shared/hooks/strings.hook';
import { contactPaths } from '../../../../../routes/employer/paths/contact.paths';
import { ButtonLink } from '../../../../shared/components/bootstrap/buttons/ButtonLink';
import { PageTitle } from '../../../../shared/components/page-components/PageTitle';

export const ContactListPageNav = (): React.ReactElement<any, any> | null => {
    const {
        nav: { application },
        contact: { list },
    } = useStrings();

    return (
        <div className="d-flex align-items-center">
            <PageTitle>{application.contacts}</PageTitle>
            <ButtonLink className="ml-2" to={contactPaths.add} icon="plus-lg">
                {list.addAction}
            </ButtonLink>
        </div>
    );
};
